import { atom } from 'recoil';

export const isCurrentProductBeingRemovedAtom = atom<boolean>({
    key: 'isCurrentProductBeingRemoved',
    default: false
});
